import { AxiosError, AxiosResponse } from 'axios';

export function isError(response: AxiosResponse) {
  return response.status >= 400 && response.status <= 599;
}

export function isNetworkError(error: AxiosError) {
  return error.message?.toLowerCase() === 'network error';
}
